// Package Imports
import { Dispatch } from 'redux';

// Types Imports
import { SET_VZ_ICON_CLICKED, SET_CURSOR_ICON_DROPPED, SET_ADD_VZ_SETTINGS, SET_VZ_NAME, SET_VZ_CREATION_MENU, SET_INIT_CURSOR_POSITION } from './types';

// Action Creators
export const setVZIconClicked = (bool: boolean) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_VZ_ICON_CLICKED,
        payload: bool,
    });
};

export const setCursorIconDropped = (bool: boolean) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_CURSOR_ICON_DROPPED,
        payload: bool,
    });
};

export const setAddVZSettings = (payload: { lat: string, lon: string, locationName: string } | null) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_ADD_VZ_SETTINGS,
        payload,
    });
};

export const setVZName = (str: string) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_VZ_NAME,
        payload: str,
    });
};

export const setVZCreationMenu = (bool: boolean) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_VZ_CREATION_MENU,
        payload: bool,
    });
};

export const setInitCursorPosition = (payload: { x: number, y: number }) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_INIT_CURSOR_POSITION,
        payload,
    });
};
